import { ErrorPlaceholder } from "../../../components/common";
import { SurveyDetailSkeleton } from "./survey-skeletons";

interface SurveyDetailContentStateProps {
  type: "loading" | "error";
  message?: string;
  onBack?: () => void;
  onRetry?: () => void;
}

export default function SurveyDetailContentState({
  type,
  message,
  onBack,
  onRetry,
}: SurveyDetailContentStateProps) {
  if (type === "loading") {
    return <SurveyDetailSkeleton />;
  }

  return (
    <div className="p-6">
      <ErrorPlaceholder
        error={message}
        onRetry={onRetry}
      />
      {onBack ? (
        <div className="flex justify-center">
          <button
            type="button"
            onClick={onBack}
            className="rounded-md border border-gray-300 px-4 py-2 text-sm dark:border-gray-600"
          >
            Back to Surveys
          </button>
        </div>
      ) : null}
    </div>
  );
}
